<template>
  <slot
    v-if="productResponse && selectedOffer && !isOutOfStock && price"
    :isOutOfStock
    :price
    :productResponse
    :selectedOffer
  >
    <Container
      v-if="productResponse && selectedOffer && !isOutOfStock && price"
      id="configurator"
      class="bg-surface-default-low"
    >
      <CustomizationFunnelWrapper
        v-if="pickersResponse"
        :is-services-pickers-response-pending
        :pickers-response
        :pickers-services="servicesPickersResponse"
        :price
        :price-without-subsidies
        :price-without-trade-in
        :product="productResponse"
        :product-tracking
        :selected-mobile-plan
        :selected-offer
      />
    </Container>
  </slot>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Container from '~/scopes/product-core/components/presentationals/Container/Container.vue'
import CustomizationFunnelWrapper from '~/scopes/product-core/components/presentationals/CustomizationFunnelWrapper/CustomizationFunnelWrapper.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchProductPrice } from '~/scopes/product-core/composables/useFetch/useFetchProductPrice/useFetchProductPrice'
import { useFetchProductTracking } from '~/scopes/product-core/composables/useFetch/useFetchProductTracking/useFetchProductTracking'
import { useFetchServicePickers } from '~/scopes/product-core/composables/useFetch/useFetchServicePickers/useFetchServicePickers'

const { data: productResponse } = useFetchProduct()
const { isOutOfStock, selectedOffer, data: pickersResponse } = useFetchPickers()
const {
  data: servicesPickersResponse,
  pending: isServicesPickersResponsePending,
} = useFetchServicePickers()
const { priceWithoutSubsidies, priceWithoutTradeIn, price } =
  useFetchProductPrice()
const { data: productTracking } = useFetchProductTracking()
const selectedMobilePlan = computed(() => {
  return (
    servicesPickersResponse.value?.pickerGroups
      ?.find(({ id }) => id === 'mobile_plan')
      ?.items?.find(({ selected }) => !!selected)?.mobilePlanOffer ?? undefined
  )
})
</script>
